import { isSupportWebp } from 'utils/dom'

const webp = {}
webp.install = (Vue, options = {}) => {
  Vue.directive('webp', {
    // 只调用一次，指令第一次绑定到元素时调用，用这个钩子函数可以定义一个在绑定时执行一次的初始化动作。
    bind: function (el, binding) {
      if (binding.value && window.supportsWebP) {
        let webpSrc = binding.value + '.webp'
        el.style.backgroundImage = 'url("' + webpSrc + '")'
        let image = new Image()
        image.onerror = function () {
          if (this.errorTag) {
            return
          }
          this.errorTag = true
          console.warn('webp背景加载出错，退回原先格式，请检查该图片路径和尺寸，错误链接为：' + webpSrc)
          el.style.backgroundImage = 'url("' + binding.value + '")'
        }
        image.src = webpSrc
      } else if (
        el.tagName.toLowerCase() === 'img' &&
        el.src &&
        el.src.indexOf('data:image') === -1 &&
        isSupportWebp()
      ) {
        var _src = el.src
        el.onerror = function () {
          if (this.errorTag) {
            return
          }
          this.errorTag = true
          console.warn('webp加载出错，退回原先格式，请检查该图片路径和尺寸，错误链接为：' + el.src)
          el.src = _src
        }
        el.src = _src + '.webp'
      }
    }
  })
}
export default webp
